import AddressFormFields from '@/components/AddressFormFields';
import { SVTextInput } from '@/components/core';
import { Card, Typography, Grid } from '@mui/material';

export default function ExternalAccountFormOwnerInfo() {
  return (
    <Card>
      <Typography variant="h5" mb={2}>
        Owner Info
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          <SVTextInput
            name="ownerName"
            label="Name on Account (i.e. owner or business name)"
            rules={{ required: true }}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography fontWeight="bold">
            Address Associated with the Account
          </Typography>
          <AddressFormFields
            line1Name="ownerAddress.line1"
            line2Name="ownerAddress.line2"
            cityName="ownerAddress.city"
            stateName="ownerAddress.state"
            postalCodeName="ownerAddress.postalCode"
          />
        </Grid>
      </Grid>
    </Card>
  );
}
